import { Pipe, PipeTransform } from '@angular/core';
import { ConvertToUnitPipe } from '../convert-font-unit/convert-to-unit.pipe';

export type FontUnit = 'rem' | 'px' | 'pt' | 'vw' | 'vh';

@Pipe({
  name: 'toFontSize',
})
export class ToFontSizePipe implements PipeTransform {
  private readonly convertFontPipe: ConvertToUnitPipe = new ConvertToUnitPipe();
  transform(
    value: number,
    srcUnit: FontUnit = 'pt',
    targetUnit: FontUnit = 'rem'
  ): string {
    return (
      this.convertFontPipe.transform(value, srcUnit, targetUnit) + targetUnit
    );
  }
}
